var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"play-navigation",attrs:{"id":"play-navigation"}},[_c('h2',{staticClass:"page-heading"},[_vm._v("Play Navigation")]),_c('ul',_vm._l((_vm.boards),function(board){return _c('li',{key:board.boardId,class:_vm.boardModeModifierClass(board.mode)},[_vm._v(" "+_vm._s(board.name)+" : "+_vm._s(board.boardId)+" "),_c('router-link',{attrs:{"to":{
          name: 'play',
          params: {boardIdOrSlug: board.slug},
        }}},[_vm._v("Play")])],1)}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }